import { Col, Row, Steps } from 'antd';
import React from 'react';

const StepContainer = ({ stepHandler, children }) => {
  return (
    <Row>
      <Col span={24}>
        <Row justify='center'>
          {
            stepHandler.status !== 'done' &&
            <Col span={24} className='mt-20'>
              <Steps
                current={stepHandler.currentStep}
                size="large"
                className="steps-container"
                items={stepHandler.steps}
                direction='horizontal'
                progressDot
                responsive={false}
              />
            </Col>
          }
        </Row>
      </Col>
      <Col span={24}>
        {children}
      </Col>
    </Row>
  );
}

export default StepContainer;